import React from "react";
import { Lightbulb, Target } from "lucide-react";

// Teach card: idea in plain language, ONE worked example, one-line why-it-matters.
export const TeachCard = ({ step }) => (
  <div className="mt-4 space-y-3" data-testid="teach-card">
    <p className="text-tc-sub leading-relaxed">{step.body}</p>
    {step.example && (
      <div className="rounded-lg bg-tc-coach/5 border border-tc-coach/20 p-3" data-testid="teach-example">
        <div className="text-[10px] font-mono uppercase tracking-widest text-tc-coach flex items-center gap-1.5"><Lightbulb className="w-3 h-3" /> Worked example</div>
        <p className="text-sm text-tc-txt mt-1">{step.example}</p>
      </div>
    )}
    {step.why && (
      <p className="text-[13px] text-tc-muted" data-testid="teach-why"><span className="text-tc-mastery font-mono uppercase text-[10px]">Why this matters:</span> {step.why}</p>
    )}
  </div>
);

// Mission purpose + plain-language primer (terms defined before the market is entered).
export const MissionPrimer = ({ purpose, primer }) => (
  <>
    {purpose && <p className="text-tc-txt mt-3 text-sm font-medium flex items-start justify-center gap-1.5" data-testid="mission-purpose"><Target className="w-4 h-4 mt-0.5 shrink-0 text-tc-coach" /> {purpose}</p>}
    {primer && (
      <div className="tc-card p-4 mt-4 text-left" data-testid="mission-primer">
        <div className="text-[10px] font-mono uppercase tracking-widest text-tc-coach">Before you start — key words</div>
        <ul className="mt-2 space-y-1.5">
          {primer.terms.map(([t, d]) => <li key={t} className="text-sm text-tc-sub"><span className="font-semibold text-tc-txt">{t}</span> — {d}</li>)}
        </ul>
        {primer.example && <p className="text-sm text-tc-txt mt-3"><span className="text-[10px] font-mono uppercase tracking-widest text-tc-coach">Worked example: </span>{primer.example}</p>}
        {primer.why && <p className="text-[13px] text-tc-muted mt-2"><span className="text-tc-mastery font-mono uppercase text-[10px]">Why this matters:</span> {primer.why}</p>}
      </div>
    )}
  </>
);
